export const DEFAULT_ROTATION_AXIS_HEIGHT = 0.5;
